/**
 * Blog Hero JavaScript
 * Image Slider with Stacked Effect
 * Performance Optimized
 */

(function() {
  'use strict';

  class BlogHeroSlider {
    constructor() {
      this.slider = document.querySelector('[data-blog-slider]');
      if (!this.slider) return;

      this.track = this.slider.querySelector('[data-slider-track]');
      this.slides = this.slider.querySelectorAll('.blog-hero__slide');
      this.prevBtn = this.slider.querySelector('[data-slider-prev]');
      this.nextBtn = this.slider.querySelector('[data-slider-next]');
      this.dots = this.slider.querySelectorAll('.blog-hero__dot');
      
      if (this.slides.length <= 1) return;

      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.isAnimating = false;

      this.init();
    }

    init() {
      // Set initial active slide
      this.setActiveSlide(0);

      // Event listeners
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.goToPrev());
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.goToNext());
      }

      // Dot navigation
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.goToPrev();
        } else if (e.key === 'ArrowRight') {
          this.goToNext();
        }
      });

      // Auto-play (optional - can be enabled via settings)
      // this.startAutoPlay();
    }

    setActiveSlide(index) {
      if (this.isAnimating) return;
      this.isAnimating = true;

      this.currentIndex = index;

      // Update slides
      this.slides.forEach((slide, i) => {
        const slideIndex = slide.dataset.slideIndex;
        const isActive = parseInt(slideIndex) === index;

        if (isActive) {
          slide.setAttribute('data-active', 'true');
          slide.style.zIndex = this.totalSlides + 1;
          slide.style.transform = 'translate(0, 0)';
        } else {
          slide.removeAttribute('data-active');
          
          // Calculate position for stacked effect
          const diff = i - index;
          let zIndex = this.totalSlides - Math.abs(diff);
          
          if (i < index) {
            // Slides before active
            slide.style.transform = `translate(-30px, 30px)`;
          } else {
            // Slides after active
            slide.style.transform = `translate(30px, -30px)`;
          }
          
          slide.style.zIndex = zIndex;
        }
      });

      // Update dots
      this.dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('blog-hero__dot--active');
        } else {
          dot.classList.remove('blog-hero__dot--active');
        }
      });

      // Reset animation flag
      setTimeout(() => {
        this.isAnimating = false;
      }, 600);
    }

    goToNext() {
      const nextIndex = (this.currentIndex + 1) % this.totalSlides;
      this.setActiveSlide(nextIndex);
    }

    goToPrev() {
      const prevIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
      this.setActiveSlide(prevIndex);
    }

    goToSlide(index) {
      if (index >= 0 && index < this.totalSlides) {
        this.setActiveSlide(index);
      }
    }

    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => {
        this.goToNext();
      }, 5000);
    }

    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new BlogHeroSlider();
    });
  } else {
    new BlogHeroSlider();
  }
})();

